import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectors } from 'darwin_core';

import PropertyScreen from '../screens/PropertyScreen.jsx';
import { getSelectedHomeId } from '../session/selectedHome.js';
import { resolveSelectedHomeId } from '../dashboard/homeSelection.js';
import { homePath } from './paths.js';

// The root (`/`) of the signed-in app. The Property page itself lives at
// /property/:homeId — the home is part of the address, so each tab, bookmark and
// history entry owns its own context and a home switch in one tab cannot change
// what another tab shows. This route only decides WHICH home a bare entry lands on
// (a bookmark of the root, the post-sign-in landing, a guard's not-found bounce):
// the home the user last looked at if this session's account still owns it
// (SECURITY: the preference is not scoped to a user on a shared browser, so it is
// validated like any other candidate), else the account's default home — and then
// replaces itself with that home's page.
//
// Two cases have no home to address, and render the Property screen here directly
// with no home context: before the account is seeded (its loading state — keeps
// the greeting up straight after sign-in instead of a bare placeholder) and an
// account that owns no homes (its empty state).
export default function PropertyLanding() {
  const homes = useSelector((state) => state.homeList.homes);
  const hadFirstHello = useSelector((state) => state.homeList.hadFirstHello);
  const defaultHomeId = useSelector(selectors.getDefaultHomeId);

  if (!hadFirstHello) {
    return <PropertyScreen />;
  }

  const homeIds = homes.map((home) => home.id);
  const homeId = resolveSelectedHomeId(
    [getSelectedHomeId(), defaultHomeId],
    homeIds,
    homeIds[0] ?? null,
  );
  if (!homeId) {
    return <PropertyScreen />;
  }
  return <Navigate to={homePath(homeId)} replace />;
}
